module.exports = __webpack_public_path__ + "img/XSYD.7dcf45bc.png";